import { render, staticRenderFns } from "./UserBoxes.vue?vue&type=template&id=5b568804"
import script from "./UserBoxes.vue?vue&type=script&lang=js"
export * from "./UserBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports